import { THEME_COLOR } from "../../config/club";

export default function PlayerStatsCards({ stats }) {
  const winRateValue = stats.gamesPlayed
    ? Math.round((stats.wins / stats.gamesPlayed) * 100)
    : 0;

  return (
    <div className="mb-4">
      {/* 1. HERO ROW: Win Rate & Total Games */}
      <div className="row g-2 mb-2">
        <div className="col-7">
          <div className="card border-0 shadow-sm h-100 position-relative overflow-hidden" 
               style={{ borderRadius: '24px', background: `linear-gradient(135deg, ${THEME_COLOR} 0%, ${THEME_COLOR}cc 100%)` }}>
            <div className="card-body p-3 text-white">
              <div className="d-flex align-items-center gap-2 mb-1 opacity-75">
                <i className="bi bi-graph-up-arrow" style={{ fontSize: '0.8rem' }}></i>
                <span style={{ fontSize: '0.65rem', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>Win Rate</span>
              </div>
              <div className="d-flex align-items-end gap-1">
                <h2 className="fw-black mb-0" style={{ fontSize: '2rem', lineHeight: '1' }}>{winRateValue}</h2>
                <span className="fw-bold mb-1" style={{ fontSize: '1rem' }}>%</span>
              </div>
              {/* Subtle abstract shape for premium feel */}
              <i className="bi bi-trophy-fill position-absolute end-0 bottom-0 mb-n2 me-n2 opacity-25" 
                 style={{ fontSize: '5rem', transform: 'rotate(-15deg)' }}></i>
            </div>
          </div>
        </div>
        
        <div className="col-5">
          <div className="card border-0 shadow-sm h-100 stat-card  bg-body-tertiary" style={{ borderRadius: '24px' }}>
            <div className="card-body p-3">
              <div className="text-muted mb-1" style={{ fontSize: '0.65rem', fontWeight: '800', textTransform: 'uppercase' }}>Total</div>
              <h3 className="fw-black mb-0">{stats.gamesPlayed || 0}</h3>
              <div className="text-muted mt-1" style={{ fontSize: '0.6rem' }}>Games Played</div>
            </div>
          </div>
        </div>
      </div>

      {/* 2. SECONDARY ROW: Wins & Losses */}
      <div className="row g-2">
        <div className="col-6">
          <div className="card border-0 shadow-sm stat-card  bg-body-tertiary"
               style={{ borderRadius: '20px', borderLeft: '4px solid #10B981' }}>
            <div className="card-body py-2 px-3 d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted" style={{ fontSize: '0.6rem', fontWeight: '800', textTransform: 'uppercase' }}>Wins</div>
                <h4 className="fw-black mb-0 text-success">{stats.wins || 0}</h4>
              </div>
              <div className="stat-icon-win rounded-circle d-flex align-items-center justify-content-center" 
                   style={{ width: '32px', height: '32px'}}>
                <i className="bi bi-check-lg text-success"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-6">
          <div className="card border-0 shadow-sm stat-card  bg-body-tertiary"
               style={{ borderRadius: '20px', borderLeft: '4px solid #EF4444' }}>
            <div className="card-body py-2 px-3 d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted" style={{ fontSize: '0.6rem', fontWeight: '800', textTransform: 'uppercase' }}>Losses</div>
                <h4 className="fw-black mb-0 text-danger">{stats.losses || 0}</h4>
              </div>
              <div className="stat-icon-loss rounded-circle d-flex align-items-center justify-content-center" 
                   style={{ width: '32px', height: '32px'}}>
                <i className="bi bi-x text-danger" style={{ fontSize: '1.2rem' }}></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .fw-black { font-weight: 900; }
        .card { transition: all 0.2s ease; }
        .card:active { transform: scale(0.96); }
      `}</style>
    </div>
  );
}